module.exports = __webpack_public_path__ + "static/netcore-993de176e94078ff5a6f398ab7a1c73e.png";